import { observer } from 'mobx-react';
import ScrollToTop from '../../../../../../ScrollToTop';
import ContinueButton from '../../../LearningCollectionSteps/ContinueButton';
import Navigation from '../Navigation';
import LearningCollectionEditStore from '../../Store';
import { EditingDetails, SavingDetails } from '../../Store/Types';
import Display from './Display';
import { useMemo } from 'react';
import { UploadImageStore } from './UploadImageStore';
import { UploadImageState } from './UploadImageStore/Types';
import { FileMetaData } from './S3ImageUpload/Types';
import { Maybe, nothing } from 'maybeasy';

interface Props {
  store: LearningCollectionEditStore;
  state: EditingDetails | SavingDetails;
}

const getFileMetaData = (state: UploadImageState): Maybe<FileMetaData> => {
  switch (state.kind) {
    case 'error':
    case 'loading':
      return nothing();
    case 'ready':
    case 'delete':
      return state.fileMetaData;
  }
};

function Details({ store, state }: Props) {
  const uploadImageStore = useMemo(() => new UploadImageStore(), []);
  return (
    <>
      <ScrollToTop />
      <div>
        <Navigation store={store}>
          <ContinueButton
            handleOnClick={() => store.savingDetails(getFileMetaData(uploadImageStore.state))}
            disabled={!store.canSave}
          />
        </Navigation>
        <div className="mx-auto max-w-clientPortalMaxWidth px-2.5 pb-4 pt-16 md:flex-row lg:px-12">
          <Display store={store} state={state} uploadImageStore={uploadImageStore} />
        </div>
      </div>
    </>
  );
}

export default observer(Details);
